const getNodes = edges => edges.map(({ node }) => node);

export default getNodes;
